<template>
  <Layout>
    <UserManagementPanel />
  </Layout>
</template>

<script setup lang="ts">
import Layout from "./Layout.vue";
import UserManagementPanel from "@/components/school/userManagement/UserManagementPanel.vue";
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
</style>
